import { ApolloClient, DefaultOptions, InMemoryCache, HttpLink, ApolloLink } from '@apollo/client'
import { environment } from './environment'
import { setContext } from '@apollo/client/link/context'
import { getTokens } from './keycloakService'

export enum GraphQLEndpoints {
  Default = 'DEFAULT',
  UserProfileServiceCs = 'CS_USER_PROFILE_SERVICE',
  UserProfileServiceNeutral = 'NEUTRAL_USER_PROFILE_SERVICE',
}

const defaultGraphQlEndpoint = new HttpLink({
  uri: `${environment.API.GQL_HTTP_URI}`,
})
const userProfileGraphQlEndpointCs = new HttpLink({
  uri: `${environment.CS.USER_PROFILE_SERVICE}`,
})
const userProfileGraphQlEndpointNeutral = new HttpLink({
  uri: `${environment.NEUTRAL.USER_PROFILE_SERVICE}`,
})

// eslint-disable-next-line
export const getApolloClient = (): ApolloClient<any> => {
  const cache = new InMemoryCache()
  const defaultOptions: DefaultOptions = {
    watchQuery: {
      fetchPolicy: 'no-cache',
      errorPolicy: 'ignore',
    },
    query: {
      fetchPolicy: 'no-cache',
      errorPolicy: 'all',
    },
  }

  const authLink = setContext((req, { headers }) => {
    // get the authentication token from local storage if it exists
    const [token] = getTokens(req.operationName)
    console.log('authLink', { token, req })
    // return the headers to the context so httpLink can read them
    return {
      headers: {
        ...headers,
        authorization: token ? `Bearer ${token}` : '',
      },
    }
  })

  return new ApolloClient({
    link: ApolloLink.split(
      (operation) => {
        console.log({ operation }, operation.getContext().clientName)
        return operation.getContext().clientName === GraphQLEndpoints.UserProfileServiceCs
      },
      authLink.concat(userProfileGraphQlEndpointCs),
      ApolloLink.split(
        (operation) => operation.getContext().clientName === GraphQLEndpoints.UserProfileServiceNeutral,
        authLink.concat(userProfileGraphQlEndpointNeutral),
        authLink.concat(defaultGraphQlEndpoint),
      ),
    ),
    cache,
    defaultOptions,
  })
}
